import { DocumentRequestModuleType } from '@enums/document-request-module-type.enum';
import { DocumentRequestStatusEnum } from '@enums/document-request-status.enum';
import { DateHelper } from '@helpers/date.helper';
import { User, UserJson } from '@models/user';

export interface DocumentRequestJson {
  id: number;
  title: string;
  status: DocumentRequestStatusEnum;
  module_type: DocumentRequestModuleType;
  description: string;
  comment: string;
  accounting_period_id: number;
  closed_by: Partial<UserJson>;
  closed_at: string;
  status_updated_at: string;
  status_updated_by: Partial<UserJson>;
  file_uuid: string;
  documents: {
    id: number;
    name: string;
  }[];
}

export class DocumentRequest {
  constructor(
    public id: number,
    public title: string,
    public status: DocumentRequestStatusEnum,
    public moduleType: DocumentRequestModuleType,
    public description: string,
    public comment: string,
    public accountingPeriodId: number,
    public closedBy: User | null,
    public closedAt: Date | null,
    public statusUpdatedAt: Date | null,
    public statusUpdatedBy: User | null,
    public fileUuid: string,
    public documents: {
      id: number;
      name: string;
    }[]
  ) {}

  static fromJson(json: Partial<DocumentRequestJson>): DocumentRequest {
    return new DocumentRequest(
      json.id,
      json.title,
      json.status,
      json.module_type,
      json.description,
      json.comment,
      json.accounting_period_id,
      json.closed_by ? User.fromJson(json.closed_by) : null,
      json.closed_at ? DateHelper.fromUtc(json.closed_at) : null,
      json.status_updated_at ? DateHelper.fromUtc(json.status_updated_at) : null,
      json.status_updated_by ? User.fromJson(json.status_updated_by) : null,
      json.file_uuid,
      json.documents
    );
  }

  static toJson(
    documentRequest: Partial<DocumentRequest>
  ): Pick<DocumentRequestJson, 'id' | 'module_type' | 'title' | 'description' | 'accounting_period_id' | 'file_uuid'> {
    return {
      id: documentRequest.id,
      title: documentRequest.title,
      module_type: documentRequest.moduleType,
      description: documentRequest.description,
      accounting_period_id: documentRequest.accountingPeriodId,
      file_uuid: documentRequest.fileUuid
    };
  }
}
